import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { Group } from '@/types/group';

type UpdateGroupNameArg = {
  groupId: string;
  groupName: string;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: UpdateGroupNameArg }
): Promise<Group> => {
  const { groupId, groupName } = arg;

  return await denApi.patch<Group, { groupName: string }>(
    `admin/group/${encodeURIComponent(groupId)}/name`,
    { groupName }
  );
};

export function useUpdateGroupName(
  swrOptions?: SWRMutationConfiguration<
    Group,
    Error,
    string,
    UpdateGroupNameArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    Group,
    Error,
    string,
    UpdateGroupNameArg
  >('admin/group/name', fetcher, swrOptions);

  return { updateGroupName: trigger, isLoading: isMutating, error };
}
